import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeedbackPanelComponent } from '../../../feedback/views/feedback-panel/feedback-panel.component';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { HighlightFeedbackPanelService } from '../../services/highlight-feedback-panel.service';
import { HighlightFeedbackItemComponent } from '../highlight-feedback-item/highlight-feedback-item.component';

@Component({
  selector: 'h3-highlight-list-panel',
  templateUrl: './highlight-feedback-list-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FeedbackPanelComponent,
    HighlightFeedbackItemComponent,
  ],
  host: {
    class: 'mat-elevation-z4 popover-panel',
  },
})
export class HighlightFeedbackListPanelComponent {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly feedbackPanelService = inject(HighlightFeedbackPanelService);

  highlightFeedbacks$ = this.store('highlightFeedbacks').$;

  close() {
    this.feedbackPanelService.close();
  }
}
